module.exports = __webpack_public_path__ + "static/media/report.d500a3bb.svg";